import script from "./EVTripPoints.vue?vue&type=script&lang=ts&setup=true"
export * from "./EVTripPoints.vue?vue&type=script&lang=ts&setup=true"

import "./EVTripPoints.vue?vue&type=style&index=0&id=530b0af4&lang=scss&scoped=true"
import "./EVTripPoints.vue?vue&type=style&index=1&id=530b0af4&lang=scss"

import exportComponent from "/builds/rentalcar-app/admin-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-530b0af4"]])

export default __exports__